/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';

import ConsentService from '../../../apiServices/ConsentService';
import { ConsentPolicyName, ConsentInterface } from '../../../models/ConsentModel';

export const types = {
  REQUEST_ALL: 'app/consent/REQUEST_ALL',
  RECEIVE_ALL: 'app/consent/RECEIVE_ALL',
};

const initialState = {};

export default function reducer(state = initialState, action: { type: string; profileId?: number; payload: object }) {
  switch (action.type) {
    case types.RECEIVE_ALL:
      const a =  _.assign({}, state, {
        [action.profileId]: action.payload,
      });

      return a;
    case types.REQUEST_ALL:
    default:
      return state;
  }
}

export const selectors = {
  getAll: (state, profileId) => _.get(state, `consent[${profileId}]`, []),
  getConsentByPolicyName(state: object, profileId, name: string) {
    return _.get(state, `consent[${profileId}][name]`, null);
  },
  getInformedConsentForProfile: (state, profileId) => {
    return _.get(state, `consent[${profileId}][${ConsentPolicyName.informedConsent}]`, null);
  },
  getInformedConsentFlow: (state, profileId) => {
    const ic: ConsentInterface = _.get(state, `consent[${profileId}][${ConsentPolicyName.informedConsent}]`, {});
    return ic ? ic.consent_detail.consent_flow : '';
  },
  getIsInformedConsentForbiddenForProfile: (state, profileId) => {
    const ic: ConsentInterface = _.get(state, `consent[${profileId}][${ConsentPolicyName.informedConsent}]`, {});
    return ic === null;
  },
};

function receiveConsents(profileId, consents) {
  return {
    type: types.RECEIVE_ALL,
    profileId,
    payload: consents,
  };
}

function requestAllConsents(profileId) {
  return (dispatch) => {
    return ConsentService.getAll(profileId)
      .then(consents => {
        dispatch(receiveConsents(profileId, consents));
        return consents;
      });
  };
}

export const actions = {
  requestAllConsents,
};
